import { Component, Input, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { DataService } from 'src/app/data.service';
import {
  LATEST_MONTH_SALES,
  PREVIOUS_YEAR_SALES,
  PRICE_CHANGE_MAPPER,
} from 'src/app/shared/shared-config';
import { LIBRARY } from 'src/app/shared/static';
import { CONFIG } from 'src/helper/app-config';
import { data } from 'src/helper/dataTable';
import { cloneDeep } from 'src/helper/utilities';
import { NEW } from 'src/shared/data-store';
import Swal from 'sweetalert2';
interface Check {
  item: string;
  value: boolean;
}
@Component({
  selector: 'app-base-scenario',
  standalone: false,
  templateUrl: './base-scenario.component.html',
  styleUrl: './base-scenario.component.scss',
})
export class BaseScenarioComponent {
  constructor(
    private dataService: DataService,
    private router: Router,
    private route: ActivatedRoute,
  ) {}

  validName = true;
  tabs = CONFIG.TABS.map((val) => val);

  @Input() moveLevel;
  baseDetails;
  childDetails;
  inputDetails;

  ngOnInit(): void {
    // this.dataService.scenarioName.subscribe((value)=>{
    //   this.scenarioName = value
    // })
    // this.dataService.scenarioName.subscribe((name) => {
    //   this.scenarioName = name;
    // });
    this.getData();
    this.route.queryParams?.subscribe((params) => {
      console.log(params);
      this.baseDetails = params?.['baseDetails'];
      if (this.baseDetails) {
        this.baseDetails = JSON.parse(this.baseDetails);
        this.scenarioName = this.baseDetails['base_scenario_name'];
      }

      this.childDetails = params?.['childDetails'];
      if (this.childDetails) {
        this.childDetails = JSON.parse(this.childDetails);
      }

      // this.selectedPrice = this.baseDetails.price;
      // this.selectedVolume = this.baseDetails.volume;
      let screen = params.tab;
      console.log(this.tabs);
      this.moveLevel(this.tabs[parseInt(screen)]);

      console.log(this.tabs[parseInt(screen)]); // popular
    });
    // this.dataService.childMode.subscribe((childMode) => {
    //   this.childMode = childMode;
    // });
  }
  getData = () => {
    this.loader = true;
    this.dataService
      .getRequest(CONFIG.API2.BASE_DATA)
      .then((res: string) => {
        // this.inputDetails= JSON.parse(res).data;
        this.inputDetails = JSON.parse(JSON.parse(res).data);
        console.log('DROP DOWN DATA', this.inputDetails);
        this.periods = this.inputDetails.Period;
        console.log('DROP DOWN DATA', this.periods);
        this.loader = false;
        console.log(this.loader);
        // this.volumeOptions = this.inputDetails.volume;
        // this.priceOptions = this.inputDetails.price_change;
        // this.categoryOptions = this.inputDetails.category.filter(ele => ele==='Pencils');
        this.periods = this.inputDetails.Period;
        // this.volumeOptions = this.volumeOptions.map((volume) => {
        //   if (volume === PREVIOUS_YEAR_SALES) {
        //     return this.volumeMapper[PREVIOUS_YEAR_SALES];
        //   }
        //   return volume;
        // });
      })
      .catch((err) => {
        this.loader = false;
        console.log(err);
      });
  };
  scenarioName = '';
  loader = false;

  volumeOptions = data['volume'];
  priceOptions = data['price_change'];
  categoryOptions = data['category'];
  timeIntervaloption = [...data['year_week'][0], ...data['year_week'][1]];
  selectedCategory: string = '';
  selectedVolume: string = '';
  selectedMonth: string = '';
  selectedPrice: string = '';
  childMode;
  periods: any = {};
  monthMapper = {
    '3 months': '3',
    '6 months': '6',
    '12 months': '12',
    '18 months': '18',
  };
  volumeMapper = {
    [PREVIOUS_YEAR_SALES]: LATEST_MONTH_SALES,
  };
  volumeReverseMapper = {
    [LATEST_MONTH_SALES]: PREVIOUS_YEAR_SALES,
    Historical: 'Forecasted',
    [PREVIOUS_YEAR_SALES]: 'Forecasted',
  };

  priceReverseMapper = {
    Monthly: 'MPI',
  };

  ViewClick(name: string) {}

  redirectToLibrary() {
    this.router.navigate(['/' + LIBRARY]);
  }

  saveAsDraft() {}

  goBack() {
    this.router.navigate(['/library']);
  }
  createBaseScenario() {
    // this.dataService.setChildId('');
    this.dataService.showLoader.next(true);
    const { username, email } =
      this.dataService.getUserDeatailsForScenarioSave();
    let payload = {
      base_scenario_name: this.scenarioName,
      category: this.selectedCategory,
      volume: this.volumeReverseMapper[this.selectedVolume]
        ? this.volumeReverseMapper[this.selectedVolume]
        : this.selectedVolume,
      price: this.priceReverseMapper[this.selectedPrice]
        ? this.priceReverseMapper[this.selectedPrice]
        : this.priceReverseMapper,
      startDate: this.selectedStartDate,
      endDate: this.selectedEndDate,
      draft: false,
      username: username,
      user_id: email,
    };
    console.log('PAYLOAD_SAVE_BASE : ', payload);
    this.dataService
      .postRequest(payload, CONFIG.API2.ADD_BASE)
      .then((res) => {
        this.dataService.showLoader.next(false);
        if (res['status'] === 400) {
          Swal.fire('Error', 'Some thing went wrong!', 'error').then(() => {
            this.router.navigate(['/library']);
            return;
          });
          return;
        }
        // Swal.fire("Success!", "Scenario created successfully", "success").
        Swal.fire({
          icon: 'success',
          html: this.scenarioName + 'Scenario created successfully',
          showConfirmButton: false,
          timer: 2000,
        });

        let paramObj = {
          base_scenario_name: this.scenarioName,
        };
        setTimeout(() => {
          this.moveLevel('Create Price Scenario', paramObj);
        }, 2500);
      })
      .catch((err) => {
        console.log(err);
      });
  }
  resetStatus() {
    this.dataService.childMode.next(NEW);
  }
  discard() {
    this.router.navigate(['/library']);
  }
  inputChange(value, key) {
    this[key] = value;
  }
  checkUniqueness(val) {
    if (!val.target.value) {
      this.validName = true;
      this.scenarioName = '';
    }
    this.scenarioName = val.target.value;
    this.scenarioName = this.scenarioName.trim();

    if (this.scenarioName) {
      this.scenarioName = this.scenarioName;
      this.dataService
        .postRequest(
          { base_scenario_name: this.scenarioName },
          CONFIG.API2.UNIQUE,
        )
        .then((res) => {
          if (res && res['status'] === 200) {
            console.log(res);

            // this.volumeOptions = this.inputDetails.volume;
            // this.priceOptions = this.inputDetails.price_change;
            // this.categoryOptions = this.inputDetails.category;
            // this.periods = this.inputDetails.Period;
            // this.volumeOptions = this.volumeOptions.map((volume) => {
            //   if (volume === PREVIOUS_YEAR_SALES) {
            //     return this.volumeMapper[PREVIOUS_YEAR_SALES];
            //   }
            //   return volume;
            // });
            this.validName = true;
          } else if (res && res['status'] === 400) {
            this.validName = false;
          } else {
            this.validName = false;
            return;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    }
  }

  checkValidDate() {
    if (this.selectedPrice === 'MPI' || this.selectedPrice === 'Monthly') {
      return (
        this.selectedStartDate.year &&
        this.selectedStartDate.month &&
        this.selectedEndDate.month &&
        this.selectedEndDate.year
      );
    } else if (this.selectedPrice === 'Post Code Plan') {
      return (
        this.selectedStartDate.year &&
        this.selectedStartDate.quarter &&
        this.selectedEndDate.quarter &&
        this.selectedEndDate.year
      );
    } else if (this.selectedPrice === 'PCM') {
      const flag =
        this.selectedStartDate.year &&
        this.selectedStartDate.month &&
        this.selectedEndDate.month &&
        this.selectedEndDate.year &&
        this.selectedEndDate.week &&
        this.selectedStartDate.week;
      return flag;
    } else return false;
  }

  // Selected dates
  selectedStartDate: {
    year: string;
    quarter: string;
    month: string;
    week: string;
  } = { year: '', quarter: '', month: '', week: '' };
  selectedEndDate: {
    year: string;
    quarter: string;
    month: string;
    week: string;
  } = { year: '', quarter: '', month: '', week: '' };

  // Event handlers for Start Date
  onStartYearChange(year: string) {
    this.selectedStartDate.year = year;
    this.commonOptionsUpdate();
  }
  onStartQuarterChange(quarter: string) {
    this.selectedStartDate.quarter = quarter;
    this.commonOptionsUpdate();
  }

  onEndQuarterChange(quarter: string) {
    this.selectedEndDate.quarter = quarter;
    this.commonOptionsUpdate();
  }

  onStartMonthChange(month: string) {
    this.selectedStartDate.month = month;
    this.commonOptionsUpdate();
  }

  onStartWeekChange(week: string) {
    this.selectedStartDate.week = week;
    this.commonOptionsUpdate();
  }

  onEndYearChange(year: string) {
    this.selectedEndDate.year = year;
    this.commonOptionsUpdate();
  }
  currentlyAvailablePeriodData = { start: {}, end: {} };

  onPriceChange() {
    this.selectedStartDate = { year: '', quarter: '', month: '', week: '' };
    this.selectedEndDate = { year: '', quarter: '', month: '', week: '' };
    console.log(this.selectedPrice);
    this.commonOptionsUpdate();
  }

  onEndMonthChange(month: string) {
    this.selectedEndDate.month = month;
    this.commonOptionsUpdate();
  }

  onEndWeekChange(week: string) {
    this.selectedEndDate.week = week;
    this.commonOptionsUpdate();
  }
  commonOptionsUpdate() {
    if (this.selectedPrice === PRICE_CHANGE_MAPPER.PCM) {
      let periodData = cloneDeep(this.inputDetails.Period);
      let yearKeys = Object.keys(periodData);
      let startMonthData = periodData[this.selectedStartDate['year']]
        ? periodData[this.selectedStartDate['year']]
        : [];
      let endMonthData = periodData[this.selectedEndDate['year']]
        ? periodData[this.selectedEndDate['year']]
        : [];
      //this.availableEndYears = Object.keys(period).slice(
      // Object.keys(period).indexOf(year),
      // );
      let endYears = this.selectedStartDate.year
        ? cloneDeep(yearKeys).slice(
            yearKeys.indexOf(this.selectedStartDate.year),
          )
        : [];
      let endMonths = [];
      if (this.selectedStartDate.year === this.selectedEndDate.year) {
        endMonths = this.selectedStartDate.month
          ? Object.keys(endMonthData).slice(
              Object.keys(startMonthData).indexOf(this.selectedStartDate.month),
            )
          : [];
      } else {
        endMonths = Object.keys(endMonthData);
      }
      let endWeek = [];
      if (
        this.selectedStartDate.year === this.selectedEndDate.year &&
        this.selectedStartDate.month === this.selectedEndDate.month
      ) {
        endWeek = this.selectedStartDate.week
          ? endMonthData[this.selectedEndDate.month].slice(
              endMonthData[this.selectedEndDate.month].indexOf(
                this.selectedStartDate.week,
              ),
            )
          : [];
      } else {
        endWeek = endMonthData[this.selectedEndDate.month];
      }
      let temp = {
        start: {
          year: yearKeys ? yearKeys.sort() : [],
          month: Object.keys(startMonthData),
          week: startMonthData[this.selectedStartDate.month]
            ? startMonthData[this.selectedStartDate.month].sort()
            : [],
        },
        end: {
          year: endYears ? endYears.sort() : [],
          month: endMonths,
          week: endWeek ? endWeek.sort() : [],
        },
      };
      console.log('=========temp=======', temp);
      this.currentlyAvailablePeriodData = temp;
    } else if (this.selectedPrice === PRICE_CHANGE_MAPPER.POST_CODE_PLAN) {
      let periodData = cloneDeep(this.inputDetails.Period_QTR);
      let yearKeys = Object.keys(periodData);
      let startQuarterData = periodData[this.selectedStartDate['year']]
        ? periodData[this.selectedStartDate['year']]
        : [];
      let endQuarterData = periodData[this.selectedEndDate['year']]
        ? periodData[this.selectedEndDate['year']]
        : [];
      let endYears = this.selectedStartDate.year
        ? cloneDeep(yearKeys).slice(
            yearKeys.indexOf(this.selectedStartDate.year),
          )
        : [];
      let endQuarter = [];
      if (this.selectedStartDate.year === this.selectedEndDate.year) {
        endQuarter = this.selectedStartDate.quarter
          ? endQuarterData.slice(
              endQuarterData.indexOf(this.selectedStartDate.quarter),
            )
          : [];
      } else {
        endQuarter = endQuarterData;
      }
      let temp = {
        start: {
          year: yearKeys ? yearKeys.sort() : [],
          quarter: startQuarterData ? startQuarterData.sort() : [],
        },
        end: {
          year: endYears ? endYears.sort() : [],
          quarter: endQuarter ? endQuarter.sort() : [],
        },
      };
      this.currentlyAvailablePeriodData = temp;
    } else {
      let periodData = cloneDeep(this.inputDetails.period_month);
      let yearKeys = Object.keys(periodData);
      let startMonthData = periodData[this.selectedStartDate['year']]
        ? periodData[this.selectedStartDate['year']]
        : [];
      let endMonthData = periodData[this.selectedEndDate['year']]
        ? periodData[this.selectedEndDate['year']]
        : [];
      let endYears = this.selectedStartDate.year
        ? cloneDeep(yearKeys).slice(
            yearKeys.indexOf(this.selectedStartDate.year),
          )
        : [];
      let endMonths = [];
      if (this.selectedStartDate.year === this.selectedEndDate.year) {
        endMonths = this.selectedStartDate.month
          ? endMonthData.slice(
              endMonthData.indexOf(this.selectedStartDate.month),
            )
          : [];
      } else {
        endMonths = endMonthData;
      }
      let temp = {
        start: {
          year: yearKeys ? yearKeys.sort() : [],
          month: startMonthData,
        },
        end: {
          year: endYears ? endYears.sort() : [],
          month: endMonths,
        },
      };
      this.currentlyAvailablePeriodData = temp;
    }
  }
}
